//Libs
import { createSelector } from "reselect";

const selectLogin = (state) => state.login;

export const selectProfile = createSelector(
  [selectLogin],
  ({ profile }) => profile
);
